import React, { useState } from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, Paper } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faqContent } from '../data/faqContent';

const FAQ = () => {
  const { title, categories, cta } = faqContent;
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <MarketingLayout>
    <Box sx={{ backgroundColor: '#f8f9fa', minHeight: '100vh', py: 8 }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700, color: '#052d50' }}>
            {title}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            Everything you need to know about investing with Angels67
          </Typography>
        </Box>

        {/* FAQ Categories */}
        {categories.map((category, categoryIndex) => (
          <Box key={categoryIndex} sx={{ mb: 6 }}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: 600, color: '#478289', mb: 3, borderBottom: '2px solid #478289', pb: 1 }}
            >
              {category.name}
            </Typography>

            {category.questions.map((item, questionIndex) => {
              const panelId = `category${categoryIndex}-question${questionIndex}`;
              return (
                <Accordion
                  key={questionIndex}
                  expanded={expanded === panelId}
                  onChange={handleChange(panelId)}
                  sx={{
                    mb: 2,
                    '&:before': { display: 'none' },
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    borderRadius: '8px !important',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      backgroundColor: 'white',
                      '&:hover': { backgroundColor: '#f5f5f5' },
                      borderRadius: '8px',
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                      {item.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ backgroundColor: '#fafafa', pt: 3, pb: 3 }}>
                    <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.secondary' }}>
                      {item.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        ))}

        {/* CTA Section */}
        <Paper
          elevation={3}
          sx={{
            background: 'linear-gradient(135deg, #052d50 0%, #478289 100%)',
            color: 'white',
            p: 6,
            textAlign: 'center',
            borderRadius: 2,
            mt: 8,
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
            {cta.title}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
            {cta.description}
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Email: <a href={`mailto:${cta.email}`} style={{ color: 'white', textDecoration: 'underline' }}>{cta.email}</a>
            </Typography>
            <Typography variant="h6">
              Phone: <a href={`tel:${cta.phone}`} style={{ color: 'white', textDecoration: 'underline' }}>{cta.phone}</a>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  
    </MarketingLayout>
  );
};

export default FAQ;
